import { LoaderCircle, X } from "lucide-react";
import { DialogHeader, Dialog, DialogContent, DialogTitle } from "components/app/dialog/dialog";
import { useEffect, useState } from "react";
import { useAppSelector } from "store/store";
import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import { Card } from "components/ui/card";
import InfiniteScroll from "react-infinite-scroll-component";
import SearchBar from "components/app/search-bar/SearchBar";
import { Button } from "components/ui/button";
import { profileVerified } from "assets";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { AppRecord, AppRecordStatus } from "models/appRecord";
import { AppLog } from "services";
import { useLocation } from "react-router-dom";

interface DialogProps {
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;
  onValueChange: (value: any) => void;
}

export default function DialogFlipFlopPage({ isDialogOpen, setIsDialogOpen, onValueChange }: DialogProps) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [searchText, setSearchText] = useState<string>("");
  const [accountLoading, setAccountLoading] = useState<any>(null);
  const [userAccount, setUserAccount] = useState<any>(null);
  const { token } = useAppSelector((state) => state.auth);
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

  const accountState = {
    currentPage: 1,
    currentIndex: 0,
    nextPageUrl: "",
    totalRecord: 0,
    loadingStatus: AppRecordStatus.loading,
  };

  const fetchMoreGetSwitchAccount = async ({ next }: { next: string }) => {
    setAccountLoading({
      ...accountState,
      loadingStatus: AppRecordStatus.loadingMore,
    });

    await RequestApi(next).then((responses) => {
      if (responses.status === "success") {
        const stateRecord: AppRecord = {
          currentPage: 1,
          currentIndex: 0,
          nextPageUrl: responses["pages"]["next_page_url"] ?? "",
          totalRecord: 0,
          loadingStatus: responses["pages"]["next_page_url"] !== null ? AppRecordStatus.noLoadMore : AppRecordStatus.loaded,
        };

        const tmpPosts = [...userAccount["data"], ...responses["pages"]["data"]];

        const newPost = { ...userAccount, data: tmpPosts };
        setUserAccount(newPost);
        setAccountLoading(stateRecord);
      }
    });
  };

  const fetchGetSwitchAccount = async () => {
    try {
      let url: string = "";

      url = RouteApi.getPageUser;
      url += `token=${token}`;

      await RequestApi(url)
        .then((responses) => {
          if (responses.status === "success") {
            const stateRecord: AppRecord = {
              currentPage: 1,
              currentIndex: 0,
              nextPageUrl: responses["pages"]["next_page_url"] ?? "",
              totalRecord: 0,
              loadingStatus: responses["pages"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
            };

            setUserAccount(responses["pages"]);
            setAccountLoading(stateRecord);
          } else {
          }
        })
        .catch((err) => {});
    } catch (error) {
      AppLog.show({
        message: `[fetchGetSwitchAccount]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const handleSubmitFlipFlopPage = async ({ pageId }: { pageId: string }) => {
    try {
      setLoadingSubmit(true);
      let url: string = "";
      url = RouteApi.submitUpdateShopPage;
      url += `token=${token}`;

      const data = {
        shop_id: shopId,
        page_id: pageId,
      };

      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        onValueChange(response);
        setIsDialogOpen(false);
      } else {
        AppLog.show({ message: response.msg, status: StatusMsg.getType(response.status) });
      }

      setLoadingSubmit(false);
    } catch (error) {
      AppLog.show({
        message: `[handleSubmitFlipFlopPage]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingSubmit(false);
    }
  };

  useEffect(() => {
    fetchGetSwitchAccount();
  }, []);

  return (
    <>
      <Dialog open={isDialogOpen}>
        <DialogContent isShowBtnXClose={false} className="max-w-[300px] md:max-w-[500px] lg:max-w-[700px]">
          <div
            className="absolute flex items-center justify-center right-4 top-2 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
            onClick={() => setIsDialogOpen(false)}
          >
            <X />
          </div>

          <DialogHeader className="relative">
            <DialogTitle>Choose the FlipFlop Page</DialogTitle>
          </DialogHeader>
          <div className="mt-4">
            <SearchBar name="SearhAccount" onValueChange={(result) => setSearchText(result)} />
          </div>
          <div className="h-[500px] max-w-[300px] md:max-w-[500px] lg:max-w-[700px] mt-4">
            {userAccount ? (
              <div id="scrollableDiv" className="h-[500px] overflow-y-auto custom-scrollbar flex justify-center w-full">
                <InfiniteScroll
                  className={`relative h-[500px]`}
                  dataLength={userAccount["data"]?.length}
                  next={() =>
                    fetchMoreGetSwitchAccount({
                      next: accountLoading.nextPageUrl,
                    })
                  }
                  scrollThreshold="90%"
                  hasMore={!!accountLoading.nextPageUrl}
                  scrollableTarget="scrollableDiv"
                  loader={
                    <div className="absolute bottom-2 left-0 w-full flex justify-center">
                      <LoaderCircle size={30} className="animate-spin text-yellow-400" />
                    </div>
                  }
                  endMessage={
                    <p className="absolute bottom-0 left-0 w-full text-center">
                      <b>Nothing more to load!</b>
                    </p>
                  }
                >
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-20">
                    {userAccount?.data?.map((user: any) => {
                      return (
                        <Card key={user.id} className="rounded-md space-y-2">
                          <div className="cursor-pointer relative overflow-hidden h-full">
                            {user.status === "Unpublished" && (
                              <div className="absolute z-10 top-0 rounded-bl-md rounded-tr-md  right-0 bg-red-700 p-2 text-white text-center font-sans py-0.5 opacity-80 flex items-center">
                                <span className="text-sm">{user.status}</span>
                              </div>
                            )}

                            {/* Name */}
                            <div className="p-2 flex flex-col justify-between h-full w-full">
                              <div className="w-full h-full">
                                <div className="">
                                  <ImageUrlProfile className="w-full object-cover h-[200px] rounded-t-md" user={user} />
                                  <div className="flex">
                                    <h1 className="font-semibold text-lg line-clamp-1">{user?.name}</h1>
                                    {user?.is_verified === "Yes" ? (
                                      <div>
                                        <div className="flex items-center justify-center pt-0.5 ml-1">
                                          <img src={profileVerified} style={{ width: 24, height: 24 }} alt="" />
                                        </div>
                                      </div>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                                <p className={`line-clamp-1`}>
                                  {user?.description}
                                  {user?.bio}
                                </p>
                              </div>
                              <div className="w-full mt-2">
                                <Button
                                  onClick={() => {
                                    handleSubmitFlipFlopPage({
                                      pageId: user.id,
                                    });
                                  }}
                                  size={"sm"}
                                  className="text-white w-full"
                                >
                                  Select
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Card>
                      );
                    })}
                  </div>
                </InfiniteScroll>
              </div>
            ) : (
              <></>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
